"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@angular/core");
const core_2 = require("@ngx-translate/core");
const Moment = require('moment');
const Cesium = window.Cesium;
class LocalizedDatePipe {
    constructor(translate) {
        this.translate = translate;
    }
    transform(date, format) {
        const currentLang = this.translate.currentLang;
        var t = (typeof date);
        if (!date)
            return 'Nil';
        // if arg is a date
        else if (format == "!-") {
            return Moment(date).locale(currentLang).fromNow();
        }
        else if (format == "!+") {
            return Moment(date).locale(currentLang).toNow();
        }
        else if (date instanceof Date)
            return Moment(date).locale(currentLang).format(format || 'DD MMM YY HH:mm');
        // otherwise if its a unix time long
        else if (t == 'number')
            return Moment(new Date(date)).locale(currentLang).format(format || 'DD MMM YY HH:mm');
        else {
            console.warn("Unspported MomentDateFormat argument " + date + ' ' + t);
            return date;
        }
    }
}
exports.LocalizedDatePipe = LocalizedDatePipe;
const material_1 = require("@angular/material");
class MatPaginatorIntlLang extends material_1.MatPaginatorIntl {
    constructor(translate) {
        super();
        this.translate = translate;
        this.getRangeLabel = function (page, pageSize, length) {
            if (length === 0 || pageSize === 0) {
                return this.pageLabel(0, length);
            }
            length = Math.max(length, 0);
            const startIndex = page * pageSize;
            // If the start index exceeds the list length, do not try and fix the end index to the end.
            const endIndex = startIndex < length ?
                Math.min(startIndex + pageSize, length) :
                startIndex + pageSize;
            return this.pageLabel(startIndex + 1, endIndex, length);
        };
        this.loadLangs();
        translate.onLangChange.subscribe(s => {
            this.loadLangs();
            this.changes.next();
        });
    }
    loadLangs() {
        this.translate.get('FILE_LIST.PAGINATION.itemsPerPage').subscribe(s => this.itemsPerPageLabel = s);
        this.translate.get('FILE_LIST.PAGINATION.nextPage').subscribe(s => this.nextPageLabel = s);
        this.translate.get('FILE_LIST.PAGINATION.previousPage').subscribe(s => this.previousPageLabel = s);
        this.translate.get('FILE_LIST.PAGINATION.lastPage').subscribe(s => this.lastPageLabel = s);
        this.translate.get('FILE_LIST.PAGINATION.firstPage').subscribe(s => this.firstPageLabel = s);
        this.translate.get('FILE_LIST.PAGINATION.pageOf', { current: '$AA', total: '$ZZ' }).subscribe(s => this.pageOf = s);
        this.translate.get('FILE_LIST.PAGINATION.pageOfLong', { currentFrom: '$AA', currentTo: '$BB', total: '$ZZ' }).subscribe(s => this.pageOfLong = s);
    }
    pageLabel(curS, curM, total) {
        if (!total)
            return this.pageOf ? this.pageOf.replace(/\$AA/g, '' + curS).replace(/\$ZZ/g, '' + curM) : '';
        else
            return this.pageOfLong ? this.pageOfLong.replace(/\$AA/g, '' + curS).replace(/\$BB/g, '' + curM).replace(/\$ZZ/g, '' + total) : '';
    }
}
exports.MatPaginatorIntlLang = MatPaginatorIntlLang;
const FILE_SIZE_UNITS = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
const FILE_SIZE_UNITS_LONG = ['Bytes', 'Kilobytes', 'Megabytes', 'Gigabytes', 'Pettabytes', 'Exabytes', 'Zettabytes', 'Yottabytes'];
class FormatFileSizePipe {
    constructor(translate) {
        this.translate = translate;
    }
    transform(sizeInBytes, longForm) {
        const units = longForm
            ? FILE_SIZE_UNITS_LONG
            : FILE_SIZE_UNITS;
        let power = Math.round(Math.log(sizeInBytes) / Math.log(1024));
        power = Math.min(power, units.length - 1);
        const size = sizeInBytes / Math.pow(1024, power); // size in new units
        const formattedSize = Math.round(size * 100) / 100; // keep up to 2 decimals
        const unit = units[power];
        return `${formattedSize} ${unit}`;
    }
}
exports.FormatFileSizePipe = FormatFileSizePipe;
class RoundPipe {
    transform(data, format = 1) {
        var mag1 = Math.pow(10, parseInt(format));
        var s = '' + Math.round(data * mag1) / mag1;
        if (s.indexOf('.') == -1) {
            var zeros = '';
            while (zeros.length < format)
                zeros += '0';
            return s + "." + zeros;
        }
        else
            return s;
    }
}
exports.RoundPipe = RoundPipe;
class DegPipe {
    transform(data, format = 1) {
        return Cesium.Math.toDegrees(data);
    }
}
exports.DegPipe = DegPipe;
class PercentPipe {
    transform(data, format) {
        var s = '' + Math.round(data * 1000) / 10;
        if (s.indexOf('.') == -1)
            return s + ".0";
        else
            return s;
    }
}
exports.PercentPipe = PercentPipe;
